import React from 'react';
// import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import {
    initHandler,
    ajaxViewHandler,
    ajaxHandler,
    setConfig,
} from "../../store/actions";
import {
    // Breadcrumb,
    // Card,
    Row,
    Col,
    // Input,
    // Button,
    // Table,
    // Modal,
    message,
    // Alert,
    // Select,
    // Tooltip,
    // Spin,
    // Form,
    // Skeleton
} from 'antd';

// import moment from 'moment';

import Config from '../../Config';
import { Helmet } from "react-helmet";
import queryString from 'query-string';

import '../../assets/laporan.css';


const configClass = {
    title: 'LAPORAN PER REKENING',
    apiUrl: {
        preview: 'laporan/api/pemutihan/',
        userProfile: "auth/api/user/info"
    },

}

class PemutihanCetak extends React.Component {
    config;

    constructor(props) {
        super(props);
        this.config = new Config();
        this.state = {
            loading: false,
            data: null,
            err: false,

            namauptppd: 'SAMSAT PALANGKARAYA',

            mulai_dari: "",
            sampai_dengan: "",
        }

        // this.preview(this.props.match.params.id);

    }

    componentDidMount() {
        var uri_params = "";
        const uri_string = queryString.parse(this.props.location.search);

        for (var key in uri_string) {
            if (uri_params == "") {
                uri_params = "?" + key + "=" + uri_string[key];
            } else {
                uri_params += "&" + key + "=" + uri_string[key];
            }
            if (key == "mulai_dari") {
                this.setState({
                    mulai_dari: uri_string[key]
                })
            } else if (key == "sampai_dengan") {
                this.setState({
                    sampai_dengan: uri_string[key]
                })
            }
        }
        this.preview(uri_params);
    }

    async preview(uri_params) {
        message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
        this.setState({
            loading: true,
            err: false,
            data: null,
        });

        this.props.ajaxViewHandler('get', configClass.apiUrl.preview + uri_params)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    message.destroy();
                    this.setState({
                        loading: false,
                        data: data,
                        err: false
                    });
                    setTimeout(function () {
                        window.print();

                    }, 1300);
                } else {
                    const errTitle = 'error get laporan';
                    this.setState({
                        loading: false,
                        data: null,
                        err: true,
                        errMsg: this.props.responseMsg
                    });
                    message.error({ content: errTitle, duration: 2, key: 'toast' });
                }
            }).catch((response) => {
                this.setState({
                    loading: false,
                    data: null,
                    err: true,
                    errMsg: 'unknown response'
                });
                console.log('gagal_get_laporan', response);
                message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
            });
    }

    render() {
        const d0 = this.state.data?.data?.[0];
        const selJenis = d0?.selected_jenis ?? [];
        const showAll = selJenis.length === 0;
        const col = {
            pokokPkb:          showAll || selJenis.includes('1'),
            dendaPkb:          showAll || selJenis.includes('2'),
            pokokTunggakPkb:   showAll || selJenis.includes('3'),
            dendaTunggakPkb:   showAll || selJenis.includes('4'),
            opsenDendaPkb:     showAll || selJenis.includes('2'),
            opsenPokokTunggak: showAll || selJenis.includes('3'),
            opsenDendaTunggak: showAll || selJenis.includes('4'),
            pokokSwdkllj:      showAll || selJenis.includes('5'),
            dendaSwdkllj:      showAll || selJenis.includes('6'),
            pokokTunggakSwd:   showAll || selJenis.includes('7'),
            dendaTunggakSwd:   showAll || selJenis.includes('8'),
        };
        const discountCols = [col.pokokPkb, col.pokokTunggakPkb, col.opsenPokokTunggak, col.pokokSwdkllj, col.pokokTunggakSwd].filter(Boolean).length;
        const pkbCols   = [col.dendaPkb, col.dendaTunggakPkb].filter(Boolean).length;
        const opsenCols = [col.opsenDendaPkb, col.opsenDendaTunggak].filter(Boolean).length;
        const swdCols   = [col.dendaSwdkllj, col.dendaTunggakSwd].filter(Boolean).length;
        const dibebaskanCols = discountCols + pkbCols + opsenCols + swdCols;

        return (
            <>
                <Helmet>
                    <title>{configClass.title}</title>
                </Helmet>
                {(this.state.data != null && d0?.status == 1 &&
                    <div className="kertas-laporan" style={{width: '100%'}}>
                        <div className="judul-laporan-pemutihan"
                            style={{
                                borderBottom: "double 5px #000000",
                                textAlign: "center",
                                width: "100%",
                                marginBottom: "20px",
                            }}>
                            {d0?.pemutihan_title ?? 'LAPORAN POKOK PKB DAN DENDA YANG DIBERIKAN PENGHAPUSAN'}
                            {d0?.title_kab && <><br />UPTPPD {d0.title_kab.toUpperCase()}</>}
                            {d0?.tgl_cari && <><br />TANGGAL {d0.tgl_cari.toUpperCase()}</>}
                        </div>
                        <table className="laporan-cetak" cellPadding="2" border="1" style={{ tableLayout: 'fixed', width: '100%' }}>
                            <thead>
                                <tr>
                                    <th rowSpan={3} style={{width: '50px'}}>NO</th>
                                    <th rowSpan={3} style={{width: '100px'}}>NOPOL</th>
                                    <th rowSpan={3} style={{width: '350px'}}>NAMA/ALAMAT/NO.HP</th>
                                    <th rowSpan={2} colSpan={2} style={{width: '180px'}}>MASA BERLAKU / KET TUNGGAKAN</th>
                                    <th rowSpan={3} style={{width: '80px'}}>WRN PLAT</th>
                                    <th rowSpan={3} style={{width: '80px'}}>JNS KEND</th>
                                    <th rowSpan={2} colSpan={2} style={{width: '200px'}}>LOKASI</th>
                                    <th colSpan={7} style={{width: '560px'}}>JUMLAH YANG DITERIMA (Rp)</th>
                                    {dibebaskanCols > 0 && <th colSpan={dibebaskanCols}>JUMLAH YANG DIBEBASKAN (Rp)</th>}
                                </tr>
                                <tr>
                                    <th colSpan={2}>POKOK PKB BERJALAN</th>
                                    <th colSpan={2}>POKOK PKB TERTUNGGAK</th>
                                    <th colSpan={3}>SWDKLLJ</th>
                                    {discountCols > 0 && <th colSpan={discountCols}>DISCOUNT</th>}
                                    {pkbCols > 0 && <th colSpan={pkbCols}>PEMBEBASAN PKB</th>}
                                    {opsenCols > 0 && <th colSpan={opsenCols}>PEMBEBASAN OPSEN</th>}
                                    {swdCols > 0 && <th colSpan={swdCols}>PEMBEBASAN SWDKLLJ</th>}
                                </tr>
                                <tr>
                                    <th style={{width: '80px'}}>DARI</th>
                                    <th style={{width: '100px'}}>S.D / KET TUNGGAK</th>
                                    <th style={{width: '90px'}}>UPT</th>
                                    <th style={{width: '90px'}}>BAYAR DI</th>
                                    <th>PKB</th>
                                    <th>OPSEN</th>
                                    <th>PKB</th>
                                    <th>OPSEN</th>
                                    <th>POKOK BERJALAN</th>
                                    <th>DENDA BERJALAN</th>
                                    <th>POKOK TUNGGAK</th>
                                    {col.pokokPkb && <th>PKB BERJALAN</th>}
                                    {col.pokokTunggakPkb && <th>PKB TUNGGAK</th>}
                                    {col.opsenPokokTunggak && <th>OPSEN PKB TUNGGAK</th>}
                                    {col.pokokSwdkllj && <th>SWD BERJALAN</th>}
                                    {col.pokokTunggakSwd && <th>SWD TUNGGAK</th>}
                                    {col.dendaPkb && <th>DENDA BERJALAN</th>}
                                    {col.dendaTunggakPkb && <th>DENDA TUNGGAK</th>}
                                    {col.opsenDendaPkb && <th>OPSEN DENDA BERJALAN</th>}
                                    {col.opsenDendaTunggak && <th>OPSEN DENDA TUNGGAK</th>}
                                    {col.dendaSwdkllj && <th>DENDA SWD BERJALAN</th>}
                                    {col.dendaTunggakSwd && <th>DENDA SWD TUNGGAK</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.data.data.map((item, idx) => (
                                    <tr key={idx}>
                                        <td style={{ textAlign: 'center' }}>{idx+1}</td>
                                        <td style={{ textAlign: 'center' }}>{item.nomor_polisi}</td>
                                        <td>
                                            {item.nama ?? ""}
                                            <p>{item.alamat}<br/>{item.no_hp}</p>
                                        </td>
                                        <td style={{ textAlign: 'center' }}>{item.tanggal_notice}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            {item.sd_notice}
                                            <p style={{color:'#555',fontSize:'0.85em',marginTop:2}}>{item.jumlah_tunggakan}</p>
                                        </td>
                                        <td style={{ textAlign: 'center' }}>{item.warna_plat}</td>
                                        <td style={{ textAlign: 'center' }}>{item.jenis_kendaraan}</td>
                                        <td style={{ textAlign: 'right' }}>{item.upt_asal ?? ""}</td>
                                        <td style={{ textAlign: 'right' }}>{item.upt_bayar ?? ""}</td>
                                        <td style={{ textAlign: 'right' }}>{item.pokok_pkb ?? ""}</td>
                                        <td style={{ textAlign: 'right' }}>{item.opsen_pokok_pkb ?? ""}</td>
                                        <td style={{ textAlign: 'right' }}>{item.tunggakan_pokok_pkb ?? ""}</td>
                                        <td style={{ textAlign: 'right' }}>{item.opsen_tunggakan_pokok_pkb ?? ""}</td>
                                        <td style={{ textAlign: 'right' }}>{item.pokok_swdkllj ?? ""}</td>
                                        <td style={{ textAlign: 'right' }}>{item.denda_swkllj ?? ""}</td>
                                        <td style={{ textAlign: 'right' }}>{item.tunggakan_pokok_swdkllj ?? ""}</td>
                                        {col.pokokPkb && <td style={{ textAlign: 'right' }}>{item.discount_pokok_pkb ?? ""}</td>}
                                        {col.pokokTunggakPkb && <td style={{ textAlign: 'right' }}>{item.discount_tunggakan_pokok_pkb ?? ""}</td>}
                                        {col.opsenPokokTunggak && <td style={{ textAlign: 'right' }}>{item.discount_tunggakan_opsen_pokok_pkb ?? ""}</td>}
                                        {col.pokokSwdkllj && <td style={{ textAlign: 'right' }}>{item.discount_pokok_swdkllj ?? ""}</td>}
                                        {col.pokokTunggakSwd && <td style={{ textAlign: 'right' }}>{item.discount_tunggakan_pokok_swdkllj ?? ""}</td>}
                                        {col.dendaPkb && <td style={{ textAlign: 'right' }}>{item.discount_denda_pkb ?? ""}</td>}
                                        {col.dendaTunggakPkb && <td style={{ textAlign: 'right' }}>{item.discount_tunggakan_denda_pkb ?? ""}</td>}
                                        {col.opsenDendaPkb && <td style={{ textAlign: 'right' }}>{item.discount_denda_opsen_pkb ?? ""}</td>}
                                        {col.opsenDendaTunggak && <td style={{ textAlign: 'right' }}>{item.discount_tunggakan_opsen_denda_pkb ?? ""}</td>}
                                        {col.dendaSwdkllj && <td style={{ textAlign: 'right' }}>{item.discount_denda_swdkllj ?? ""}</td>}
                                        {col.dendaTunggakSwd && <td style={{ textAlign: 'right' }}>{item.discount_tunggakan_denda_swdkllj ?? ""}</td>}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <br /><br />
                        <table>
                            <tbody>
                                <tr className='teks-tengah'>
                                    <td>
                                        Mengetahui,<br />
                                        {this.state.data.ttd.kiri.jabatan}
                                    </td>
                                    <td>
                                        <br/>
                                        {this.state.data.ttd.kanan.jabatan}
                                    </td>
                                </tr>
                                <tr className='teks-tengah' cellPadding="5">
                                    <td><b>{this.state.data.ttd.kiri.nama}</b></td>
                                    <td><b>{this.state.data.ttd.kanan.nama}</b></td>
                                </tr>
                                <tr className='teks-tengah'>
                                    <td>{this.state.data.ttd.kiri.nip}</td>
                                    <td>{this.state.data.ttd.kanan.nip}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )}
            </>
        )
    }

}

const mapStateToProps = function (state) {
    return state.configReducers
}

export default connect(
    mapStateToProps,
    {
        initHandler,
        setConfig,
        ajaxViewHandler,
        ajaxHandler,
    }
)(PemutihanCetak);